const Colors = {
  dark: {
    '--dark-bg-color': '#030008',
    '--bg-color': '#060010',
    '--light-bg-color': '#0e0824',
    '--lightest-bg-color': '#1b1236',
    '--bg-color-shadow': 'rgba(3, 0, 8, 0.8)',
    '--dark-text-color': '#4b4568',
    '--text-color': '#9a94b8',
    '--light-text-color': '#bcb7d6',
    '--lightest-text-color': '#ece9ff',
    '--contrast-color': '#ffffff',
    '--primary-color': '#ffffff',
    '--primary-color-tint': 'rgba(167, 139, 250, 0.14)',
    '--highlight-tint': 'rgba(167, 139, 250, 0.06)',
    '--outline-light': 'rgba(167, 139, 250, 0.18)',
    '--signal-color': '#a78bfa',
    '--signal-color-tint': 'rgba(167, 139, 250, 0.14)',
    '--signal-soft': '#c4b5fd',
    '--on-signal': '#060010',
    '--glow-color': 'rgba(124, 92, 255, 0.35)',
    '--aurora-opacity': '1',
    '--nav-bg': 'rgba(6, 0, 16, 0.55)',
  },
  light: {
    '--dark-bg-color': '#efeaff',
    '--bg-color': '#faf8ff',
    '--light-bg-color': '#ffffff',
    '--lightest-bg-color': '#ece6ff',
    '--bg-color-shadow': 'rgba(60, 30, 140, 0.12)',
    '--dark-text-color': '#8b84ab',
    '--text-color': '#5a5478',
    '--light-text-color': '#352f55',
    '--lightest-text-color': '#140d30',
    '--contrast-color': '#140d30',
    '--primary-color': '#140d30',
    '--primary-color-tint': 'rgba(109, 40, 217, 0.1)',
    '--highlight-tint': 'rgba(109, 40, 217, 0.05)',
    '--outline-light': 'rgba(109, 40, 217, 0.18)',
    '--signal-color': '#6d28d9',
    '--signal-color-tint': 'rgba(109, 40, 217, 0.12)',
    '--signal-soft': '#8b5cf6',
    '--on-signal': '#ffffff',
    '--glow-color': 'rgba(109, 40, 217, 0.2)',
    '--aurora-opacity': '0.5',
    '--nav-bg': 'rgba(250, 248, 255, 0.65)',
  },
};

export default Colors;
